import AgentChatScreen from 'components/Dashboard/AgentChatScreen'
import React from 'react'
import { AgentTabView } from 'constants/ChatViewConstants';
import { connect } from "react-redux";
import AgentRequestCallBack from 'components/AgentRequestCallBack/AgentRequestCallBack';
import AgentRaiseQuery from 'components/AgentRaiseQuery/AgentRaiseQuery';

function AgentRightSection(props) {
    const { agentTab } = props;
    const selectedSection = agentTab.section;
    const renderBasedOnSelectedSection = () => {
        switch (selectedSection) {
            case AgentTabView.AGENT_CHAT:
                return <AgentChatScreen />;
            case AgentTabView.RAISE_QUERY:
                return <AgentRaiseQuery />;
            case AgentTabView.REQUEST_CALLBACK:
                return <AgentRequestCallBack />;
            default:
                return "";
        }
    };
    return (
        <>
            {renderBasedOnSelectedSection()}
        </>
    );
}


const mapStateToProps = (state) => ({
    agentTab: state.agentTab,
});
export default connect(mapStateToProps)(AgentRightSection);